import { useMutation, useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { AxiosResponse } from 'axios'

import { axiosInstance } from '../../helpers'
import { GuestCard, GuestCardPremiumOption } from '../../models/Outreach/types'
import { School } from '../../models/types'
import { UnitConfigAreaCounts } from '../../models/Config/types'

export interface GuestCardLinkFormResponse {
    guest_card: GuestCard
    apartment_name: string
    unit_configs: UnitConfigAreaCounts[]
    premiums?: GuestCardPremiumOption[]
    schools?: School[]
    preselected_unit_config: UnitConfigAreaCounts | null
    already_submitted?: boolean
    default_move_in_date?: string | null
    default_move_out_date?: string | null
}

export interface GuestCardLinkFormRequest {
    name?: string
    email?: string
    phone?: string
    floor_plan?: number
    preferred_premiums?: number[]
    preferred_rent_cost?: string
    preferred_move_in_date?: string
    preferred_move_out_date?: string
    additional_occupants?: {
        name: string
        email: string
        phone: string
    }[]
    school?: number
    additional_requests?: string
    custom_questions?: {
        question: number
        answer: string
    }[]
}

export const useGuestCardLinkForm = (token: string | undefined) => {
    const { data, isLoading, error } = useQuery<
        AxiosResponse<GuestCardLinkFormResponse>,
        Error
    >({
        queryKey: ['guest-card-link-form', token],
        queryFn: () => axiosInstance.get(`/outreach/guest-card-link/${token}/`),
        enabled: !!token,
    })

    const submitGuestCardLinkForm = useMutation({
        mutationFn: (request: GuestCardLinkFormRequest) =>
            axiosInstance.post(`/outreach/guest-card-link/${token}/`, request),
        onSuccess: () => {
            toast.success('Guest card form submitted successfully')
        },
        onError: () => {
            toast.error('Failed to submit guest card form')
        },
    })

    return {
        formData: data?.data,
        isLoading,
        error,
        submitGuestCardLinkForm,
    }
}
